import React, {useEffect, useState} from "react";

import { Box, Button, Column, Columns, Control, Field, Input, Select, Title } from "@allxsmith/bestax-bulma";
import {createSetVehicleFieldAction} from "../../actions/dataActions";
import axios from "axios";
import {useDispatch} from "react-redux";
import KeyPicker from "./KeyPicker";
import ServicePackPicker from "./ServicePackPicker";

function FeaturesSection(props) {
  const dispatch = useDispatch();
  const [, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [oldTracker, setOldTracker] = useState();
  const [servicePack, setServicePack]  = useState();

  useEffect(() => {
    setOldTracker(props.data.tracker);
    setServicePack(props.data.service_pack_fk);
    // if(props.data.service_pack_fk){
    //   props.servicePacks.results.push(props.data.service_pack_fk)
    // }
  }, props)

  const updateOldTracker = async (oldTracker) => {
    if(oldTracker) {
      const data = {
        ...oldTracker,
        vehicle: null,
      }
      return axios.put(`/api/vehicletracker/${oldTracker.id}`, data).then(res => console.log('old tracker updated', res));
    }
  }

  const updateNewTracker = async (tracker) => {
    const updatedTracker = {
      ...tracker,
      vehicle: props.data
    }
    return axios.put(`/api/vehicletracker/${tracker.id}`, updatedTracker).then(() => {
      dispatch(createSetVehicleFieldAction({tracker: updatedTracker}));
      setOldTracker(updatedTracker);
    })
  }

  const handleClear = () => {
    updateOldTracker(oldTracker).then(() => setOldTracker(null));
  }

  useEffect(() => {
    setLoading(true);
    axios
        .get(`/api/vehicletracker/searchunused`)
        .then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
  }, [oldTracker]);

  const handleSelectChange = (e) => {
    const trackerId = Number(e.target.value);
    // find tracker object in search data
    const selectedTracker = searchData.find(tracker => tracker.id === trackerId);
    dispatch(createSetVehicleFieldAction({tracker: selectedTracker}));
    updateOldTracker(oldTracker).then(() => updateNewTracker(selectedTracker).then(() => setOldTracker(selectedTracker)))
  }
    const keyObjects = props.keys.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
  }, {});


  const onKeyChange = e => {
        const {name, value} = e.target;
        dispatch(createSetVehicleFieldAction({[name]: keyObjects[value]}));
  };

  return (
    <Box>
      <details>
        <summary><Title>Features</Title></summary>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Current Key Number</label>
            <Input
              readOnly={true}
              disabled={true}
              value={props.data ? props.data.key ? props.data.key.key_number : "" : ""}
            />
          </Field>
        </Column>
        <Column>
          <KeyPicker
            keys={props.keys}
            onKeyChange={onKeyChange}
            selectedKey={props.data.key}
            clearButton={true}
            dataFresh={props.dataFresh}
            onClear={props.onKeyClear}
            spare={false}
          />
        </Column>
        <Column>
          <Field>
            <label className="label">Spare Key Number</label>
            <Input
              readOnly={true}
              disabled={true}
              value={props.data ? props.data.spare_key ? props.data.spare_key.board+" "+props.data.spare_key.key_number : "" : ""}
            />
          </Field>
        </Column>
        <Column>
          <KeyPicker
            keys={props.keys}
            onKeyChange={onKeyChange}
            selectedKey={props.data.spare_key}
            clearButton={true}
            dataFresh={props.dataFresh}
            onClear={props.onKeyClear}
            spare={true}
          />
        </Column>
        <Column>
          <label className="label">Tracker IMEI</label>
          <Field className={"has-addons"}>
              <Control>
                <Select
                    onChange={handleSelectChange}
                    value={oldTracker ? oldTracker.id : -1}
                    placeholder="Select Tracker"
                >
                  {!oldTracker && <option disabled={true} value={-1} selected={!oldTracker}>Select Tracker</option>}
                  {oldTracker && <option value={oldTracker?.id} disabled={true}>{oldTracker.imei}</option>}
                  {searchData.map(tracker => <option value={tracker.id}>{tracker.imei}</option>)}
                </Select>
              </Control>
              {oldTracker && oldTracker.imei &&
                  <Button
                      tabIndex={-1}
                      onClick={handleClear}
                      className="is-pulled-right"
                      disabled={props.disabled}
                      style={{display: 'inline'}}
                      color={"danger"}
                  >
                    Remove Tracker
                  </Button>
              }
          </Field>
        </Column>
        <Column>
          <ServicePackPicker
            options={props.servicePacks}
            value={props.data.service_pack_fk}
            blank={true}
            editable={true}
            label={"Service Pack Number"}
            onChange={props.onServicePackChange}
            additionalOptions={servicePack && servicePack.id ? [servicePack] : []}
          />
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Service pack</label>
            <input
                className="checkbox"
                type="checkbox"
                name="service_pack"
                onChange={props.handleCheckbox}
                checked={props.data.service_pack}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Camera</label>
            <input
                className="checkbox"
                type="checkbox"
                name="camera"
                onChange={props.handleCheckbox}
                checked={props.data.camera}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Log Book</label>
            <input
                className="checkbox"
                type="checkbox"
                name="log_book"
                onChange={props.handleCheckbox}
                checked={props.data.log_book}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Anti Drill Plate</label>
            <input
                className="checkbox"
                type="checkbox"
                name="anti_drill_plate"
                onChange={props.handleCheckbox}
                checked={props.data.anti_drill_plate}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Window Stickers</label>
            <input
                className="checkbox"
                type="checkbox"
                name="window_stickers"
                onChange={props.handleCheckbox}
                checked={props.data.window_stickers}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Fire Extinguisher</label>
            <input
                className="checkbox"
                type="checkbox"
                name="fire_extinguisher"
                onChange={props.handleCheckbox}
                checked={props.data.fire_extinguisher}
            />
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Body Serial Number</label>
            <Input
                type="text"
                name="body_serial_number"
                onChange={props.onChange}
                value={props.data.body_serial_number}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Tail Lift Serial number</label>
            <Input
                type="text"
                name="tail_lift_serial_number"
                onChange={props.onChange}
                value={props.data.tail_lift_serial_number}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Gross Vehicle Weight</label>
            <Input
                type="text"
                name="gross_vehicle_weight"
                onChange={props.onChange}
                value={props.data.gross_vehicle_weight}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Payload</label>
            <Input
                type="text"
                name="payload"
                onChange={props.onChange}
                value={props.data.payload}
            />
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Slam Lock Key Number</label>
            <Input
                type="text"
                name="slam_lock_number"
                onChange={props.onChange}
                value={props.data.slam_lock_number}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Tyre Size</label>
            <Input
                type="text"
                name="tyre_size"
                onChange={props.onChange}
                value={props.data.tyre_size}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Radio Code</label>
            <Input
                type="text"
                name="radio_code"
                onChange={props.onChange}
                value={props.data.radio_code}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Oil Type</label>
            <Input
                type="text"
                name="oil_type"
                onChange={props.onChange}
                value={props.data.oil_type}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Oil Quantity</label>
            <Input
                type="text"
                name="oil_quantity"
                onChange={props.onChange}
                value={props.data.oil_quantity}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Customer's Equipment</label>
            <Input
                type="text"
                name="customer_equipment"
                onChange={props.onChange}
                value={props.data.customer_equipment}
            />
          </Field>
        </Column>
      </Columns>
      </details>
    </Box>
  );
}

export default FeaturesSection;
